import TmParser from "../../js/entities/TuringMachine/TmParser";
import {
    TmParsingError,
    TmParsingException
} from "../../js/errors/Exceptions";
import TmStateInputComponent, {getStateInputId, parseStateInputIndexFromId} from "./TmStateInputComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import LineByLineTextErrorsComponent from "./LineByLineTextErrorsComponent";
import TmTransitionRuleInputComponent from "./TmTransitionRuleInputComponent";
import {TmAlphabet} from "../../js/entities/TuringMachine/TmAlphabet";
import {TmState, findStateByName} from "../../js/entities/TuringMachine/TmState";
import {TmHeadTransitionDirection, TmTransitionRule} from "../../js/entities/TuringMachine/TmTransitionRule";
import {TmTransitionsRelation} from "../../js/entities/TuringMachine/TmTransitionsRelation";
import {containsEqualElement, containsWhitespace, exportJsonFile, exportTextFile, isString} from "../../js/utils";


export default function TmCreateModeComponent({createModeState,
                                                  setCreateModeState,
                                                  switchToRunMode}){

/*
    console.log("States inputs:");
    console.log(JSON.parse(JSON.stringify(createModeState.statesInputs))); ///////////////////////////////////////////////////////

    console.log("States inputs errors:");
    console.log(JSON.parse(JSON.stringify(createModeState.statesInputsErrors))); /////////////////////////////////////////////////

    console.log("Initial state input:");
    console.log(createModeState.initialStateInputId); /////////////////////////////////////////////////


    console.log("Alphabet chars");
    console.log(createModeState.alphabetChars);////////////////////////////////

    console.log("Alphabet empty cell char");
    console.log(createModeState.alphabetEmptyCellChar);////////////////////////////////

    console.log("Unique states");
    console.log(createModeState.uniqueValidStatesNames);////////////////////////////////

    console.log("Transition rules inputs:");
    console.log(JSON.parse(JSON.stringify(createModeState.transitionRulesInputs))); /////////////////////////////////////////////////
*/


    /***** Handlers for alphabet input *****/

    /**
     *
     * @param chars {string[]} not empty array of alphabet chars (length=1).
     * Each char must have not bigger than 1 entry
     * @param emptyCellChar must be contained in the <code>chars</code>
     */
    const onSetAlphabet = (chars, emptyCellChar) => {

        // change value of corresponding inout
        document.getElementById('input-alphabet-chars').value = chars.join('');

        setCreateModeState((state) => ({
            ...state,
            alphabetChars: chars,
            alphabetCharsInputErrors: [],
            alphabetEmptyCellChar: emptyCellChar,

            // update input for transition rules according to updated alphabetChars
            transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput) => ({
                ...transitionRuleInput,
                lookedChar: chars.includes(transitionRuleInput.lookedChar)
                    ? transitionRuleInput.lookedChar
                    : '',
                charToWrite: chars.includes(transitionRuleInput.charToWrite)
                    ? transitionRuleInput.charToWrite
                    : ''
            }))
        }));
    }

    const onSetBinaryAlphabet = (event) => {
        event.preventDefault();

        onSetAlphabet(['0', '1', '*'], '*');
    }

    const onSetDigitAlphabet = (event) => {
        event.preventDefault();

        onSetAlphabet(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*'], '*');
    }

    // also need to check transition relation input the same as in changing field

    const onAlphabetCharsInputChanged = (event) => {
        event.preventDefault();

        let alphabetChars = [];
        let errors = [];

        // try to parse
        try{
            alphabetChars = TmParser.parseTmAlphabetChars(event.target.value);
            alphabetChars = [...new Set(alphabetChars)];
        }
        catch(e){ // error can be only when alphabet is empty
            if (e instanceof TmParsingException) {
                errors = e.errors;
            }
            else {
                errors = [new TmParsingError('alphabet-input', undefined, 'unknown error')];
            }
        }

        // if no errors, then alphabetChars is not empty and errors = []
        // if some errors, then alphabetChars = [] and errors is not empty

        setCreateModeState((state) => ({
            ...state,
            alphabetChars: alphabetChars,
            alphabetCharsInputErrors: errors,
            alphabetEmptyCellChar: (alphabetChars.includes(state.alphabetEmptyCellChar))
                ? state.alphabetEmptyCellChar // don't change, if old emoty-cell char is contained in new alphabet
                : '', // make unselected when old empty-cell char is in new alphabet

            // update input for transition rules according to updated alphabetChars
            transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput) => ({
                ...transitionRuleInput,
                lookedChar: alphabetChars.includes(transitionRuleInput.lookedChar)
                    ? transitionRuleInput.lookedChar
                    : '',
                charToWrite: alphabetChars.includes(transitionRuleInput.charToWrite)
                    ? transitionRuleInput.charToWrite
                    : ''
            }))
        }));
    }

    const onAlphabetEmptyCellCharChanged = (event) => {
        event.preventDefault();

        setCreateModeState((state) => ({
            ...state,
            alphabetEmptyCellChar: event.target.value
        }));
    }


    /***** Handlers for states inputs *****/

    const onAddStateInput = (event) => {
        event.preventDefault();

        setCreateModeState((state) => ({
            ...state,

            statesInputs: [...state.statesInputs, {
                name: '',
                description: '',
                final: false
            }],
            statesInputsErrors: [...state.statesInputsErrors, []]
        }));
    }

    const onStateInputNameChanged = (newName, stateInputIndex) => {

        // check for possible errors
        let errors = [];
        if(newName.length > 0){
            if(!/^[a-z0-9_]+$/.test(newName)){ // if newName doesn't match required format
                errors.push(new TmParsingError('state-input-name', undefined,
                    'Name can contain only latin characters, digits and underscores'));
            }
            /// NEED TO CHECK uniqueness by name on compilation phase, or simply consider only the first one
            // if(getStateInputsNames().includes(newName)){
            //     errors.push(new TmParsingError('state-input-name', undefined,
            //         'Name must be unique'));
            // }
        }
        else{
            errors.push(new TmParsingError('state-input-name', undefined, 'Name must be not empty'));
        }

        // apply changes
        setCreateModeState((state) => {

            let newStatesInputs = state.statesInputs.map((stateInput, idx) => {
                if (idx !== stateInputIndex) { // not target stateInput
                    return stateInput;
                } else {
                    return {
                        ...stateInput,
                        name: newName
                    }
                }
            });

            let newUniqueValidStatesNames = [
                ...new Set(
                    newStatesInputs
                    .map(si => si.name)
                    .filter((name) => (name.length > 0) && /^[a-z0-9_]+$/.test(name))
                )
            ];

            return {
                ...state,

                // change name only for target stateInput (which index is stateInputIndex)
                statesInputs: newStatesInputs,

                // change errors only for target stateInput (which index is stateInputIndex)
                statesInputsErrors: state.statesInputsErrors.map((stateInputErrors, idx) => {
                    if (idx !== stateInputIndex) { // not target stateInput
                        return stateInputErrors;
                    } else {
                        // delete old errors for name (filtering by part), and then push fresh errors
                        return stateInputErrors.filter((e) => e.part !== 'state-input-name').concat(errors);
                    }
                }),

                uniqueValidStatesNames: newUniqueValidStatesNames,

                // update input for transition rules according to updated alphabetChars
                transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput) => ({
                    ...transitionRuleInput,
                    startState: newUniqueValidStatesNames.includes(transitionRuleInput.startState)
                        ? transitionRuleInput.startState
                        : '',
                    endState: newUniqueValidStatesNames.includes(transitionRuleInput.endState)
                        ? transitionRuleInput.endState
                        : '',
                }))
            }
        });
    }

    const onStateInputDescriptionChanged = (newDescription, stateInputIndex) => {
        // apply changes
        setCreateModeState((state) => ({
            ...state,

            // change description only for target stateInput (which index is stateInputIndex)
            statesInputs: state.statesInputs.map((stateInput, idx) => {
                if(idx !== stateInputIndex){ // not target stateInput
                    return stateInput;
                }
                else{
                    return{
                        ...stateInput,
                        description: newDescription
                    }
                }
            })
        }));
    }

    const onInitialStateInputChanged = (newInitialStateInputId) => {
        setCreateModeState((state) => ({
            ...state,
            initialStateInputId: newInitialStateInputId
        }));
    }

    const onStateInputFinalChanged = (stateInputIndex) => {
        // apply changes
        setCreateModeState((state) => ({
            ...state,

            // change final only for target stateInput (which index is stateInputIndex)
            statesInputs: state.statesInputs.map((stateInput, idx) => {
                if(idx !== stateInputIndex){ // not target stateInput
                    return stateInput;
                }
                else{
                    return{
                        ...stateInput,
                        final: !stateInput.final // change final of target stateInput to opposite value
                    }
                }
            })
        }));
    }


    const onRaiseUpStateInput = (stateInputIndex) => {
        if(stateInputIndex === 0){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }

        // need to change: statesInputs, initialStateInputId, statesInputsErrors

        // memorize prev and target input, and errors
        let prevStateInput = createModeState.statesInputs[stateInputIndex - 1];
        let targetStateInput = createModeState.statesInputs[stateInputIndex];

        let prevStateInputErrors = createModeState.statesInputsErrors[stateInputIndex - 1];
        let targetStateInputErrors = createModeState.statesInputsErrors[stateInputIndex];

        // change initialStateInputId
        let newInitialStateInputId = undefined;
        if(createModeState.initialStateInputId){
            let initialStateInputIndex = parseStateInputIndexFromId(createModeState.initialStateInputId);

            if(initialStateInputIndex === stateInputIndex){
                newInitialStateInputId = getStateInputId(stateInputIndex - 1); // up target
            }
            else if(initialStateInputIndex === stateInputIndex - 1){
                newInitialStateInputId = getStateInputId(stateInputIndex); // down prev
            }
            else{
                newInitialStateInputId = createModeState.initialStateInputId;
            }
        }

        setCreateModeState((state) => ({
            ...state,

            // swap prev and target inputs
            statesInputs: state.statesInputs.map((stateInput, idx) => {
                if(idx === stateInputIndex - 1){
                    return targetStateInput;
                }
                else if (idx === stateInputIndex){
                    return prevStateInput;
                }
                else{
                    return stateInput;
                }
            }),

            // swap prev and target errors
            statesInputsErrors: state.statesInputsErrors.map((stateInputErrors, idx) => {
                if(idx === stateInputIndex - 1){
                    return targetStateInputErrors;
                }
                else if (idx === stateInputIndex){
                    return prevStateInputErrors;
                }
                else{
                    return stateInputErrors;
                }
            }),

            // set new initial state
            initialStateInputId: newInitialStateInputId
        }));
    }

    const onPutDownStateInput = (stateInputIndex) => {
        if(stateInputIndex === createModeState.statesInputs.length - 1){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }


        // need to change: statesInputs, initialStateInputId, statesInputsErrors

        // memorize prev and target input, and errors
        let targetStateInput = createModeState.statesInputs[stateInputIndex];
        let nextStateInput = createModeState.statesInputs[stateInputIndex + 1];

        let targetStateInputErrors = createModeState.statesInputsErrors[stateInputIndex];
        let nextStateInputErrors = createModeState.statesInputsErrors[stateInputIndex + 1];

        // change initialStateInputId
        let newInitialStateInputId = undefined;
        if(createModeState.initialStateInputId){
            let initialStateInputIndex = parseStateInputIndexFromId(createModeState.initialStateInputId);

            if(initialStateInputIndex === stateInputIndex){ // target is initial
                newInitialStateInputId = getStateInputId(stateInputIndex + 1); // down target
            }
            else if(initialStateInputIndex === stateInputIndex + 1){ // next is initial
                newInitialStateInputId = getStateInputId(stateInputIndex); // up next
            }
            else{
                newInitialStateInputId = createModeState.initialStateInputId;
            }
        }

        setCreateModeState((state) => ({
            ...state,

            // swap target and next inputs
            statesInputs: state.statesInputs.map((stateInput, idx) => {
                if(idx === stateInputIndex){
                    return nextStateInput;
                }
                else if (idx === stateInputIndex + 1){
                    return targetStateInput;
                }
                else{
                    return stateInput;
                }
            }),

            // swap target and next errors
            statesInputsErrors: state.statesInputsErrors.map((stateInputErrors, idx) => {
                if(idx === stateInputIndex){
                    return nextStateInputErrors;
                }
                else if (idx === stateInputIndex + 1){
                    return targetStateInputErrors;
                }
                else{
                    return stateInputErrors;
                }
            }),

            // set new initial state
            initialStateInputId: newInitialStateInputId
        }));
    }

    const onDeleteStateInput = (stateInputIndex) => {
        if(createModeState.statesInputs.length < 2){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }

        setCreateModeState((state) => {

            // calc newInitialStateInputId
            let newInitialStateInputId = undefined;

            if(state.initialStateInputId !== undefined){
                let initialStateInputIndex = parseStateInputIndexFromId(state.initialStateInputId);
                if(initialStateInputIndex < stateInputIndex){
                    newInitialStateInputId = state.initialStateInputId; // do not change
                }
                else if(initialStateInputIndex > stateInputIndex){
                    newInitialStateInputId = getStateInputId(initialStateInputIndex - 1) // decrement
                }
                // else, we want to delete exactly initial input item, so set newInitial to undefined
            }

            // filter out target stateInput
            let newStatesInputs = state.statesInputs.filter((stateInput, idx) => {
                return idx !== stateInputIndex; // accept all, except target stateInput
            });
            let newStatesInputsErrors = state.statesInputsErrors.filter((stateInputErrors, idx) => {
                return idx !== stateInputIndex; // accept all, except target stateInput
            })

            // can't simply filter out delete name from newUniqueValidStatesNames,
            // because it can be two stateInputs with this name
            let newUniqueValidStatesNames = [
                ...new Set(
                    newStatesInputs
                        .map(si => si.name)
                        .filter((name) => (name.length > 0) && /^[a-z0-9_]+$/.test(name))
                )
            ];

            return {
                ...state,
                statesInputs: newStatesInputs,
                statesInputsErrors: newStatesInputsErrors,
                initialStateInputId: newInitialStateInputId,

                uniqueValidStatesNames: newUniqueValidStatesNames,

                // update input for transition rules according to updated alphabetChars
                transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput) => ({
                    ...transitionRuleInput,
                    startState: newUniqueValidStatesNames.includes(transitionRuleInput.startState)
                        ? transitionRuleInput.startState
                        : '',
                    endState: newUniqueValidStatesNames.includes(transitionRuleInput.endState)
                        ? transitionRuleInput.endState
                        : '',
                }))
            };
        });
    }


    /***** Handlers for transitions rules inputs *****/


    /**
     * Set value of <code>createModeState.transitionRulesInputs[transitionRuleInputIndex].propertyName</code> to
     * given <code>value</code>.
     * @param property
     * @param value
     * @param transitionRuleInputIndex
     */
    const setTransitionRuleInputValue = (propertyName, value, transitionRuleInputIndex) => {
        setCreateModeState((state) => ({
            ...state,

            // change given property only for target transitionRuleInput (which index is transitionRuleInputIndex)
            transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput, idx) => {
                if(idx !== transitionRuleInputIndex){ // not target stateInput
                    return transitionRuleInput;
                }
                else{
                    return{
                        ...transitionRuleInput,
                        [propertyName]: value // This is where changes are made
                    }
                }
            })
        }));
    }


    const onTransitionRuleInputStartStateChanged = (newStartState, transitionRuleInputIndex) => {
        setTransitionRuleInputValue('startState', newStartState, transitionRuleInputIndex);
    }

    const onTransitionRuleInputLookedCharChanged = (newLookedChar, transitionRuleInputIndex) => {
        setTransitionRuleInputValue('lookedChar', newLookedChar, transitionRuleInputIndex);
    }

    const onTransitionRuleInputEndStateChanged = (newEndState, transitionRuleInputIndex) => {
        setTransitionRuleInputValue('endState', newEndState, transitionRuleInputIndex);
    }

    const onTransitionRuleInputCharToWriteChanged = (newCharToWrite, transitionRuleInputIndex) => {
        setTransitionRuleInputValue('charToWrite', newCharToWrite, transitionRuleInputIndex);
    }

    const onTransitionRuleInputHeadDirectionChanged = (newHeadDirection, transitionRuleInputIndex) => {
        setTransitionRuleInputValue('headDirection', newHeadDirection, transitionRuleInputIndex);
    }

    const onRaiseUpTransitionRuleInput = (transitionRuleInputIndex) => {
        if(transitionRuleInputIndex === 0){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }

        // memorize prev and target input
        let prevTransitionRuleInput = createModeState.transitionRulesInputs[transitionRuleInputIndex - 1];
        let targetTransitionRuleInput = createModeState.transitionRulesInputs[transitionRuleInputIndex];

        setCreateModeState((state) => ({
            ...state,

            // swap prev and target inputs:
            transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput, idx) => {
                if(idx === transitionRuleInputIndex - 1){
                    return targetTransitionRuleInput;
                }
                else if (idx === transitionRuleInputIndex){
                    return prevTransitionRuleInput;
                }
                else{
                    return transitionRuleInput;
                }
            })
        }));
    }

    const onPutDownTransitionRuleInput = (transitionRuleInputIndex) => {
        if(transitionRuleInputIndex === createModeState.transitionRulesInputs.length - 1){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }

        // memorize target and next input
        let targetTransitionRuleInput = createModeState.transitionRulesInputs[transitionRuleInputIndex];
        let nextTransitionRuleInput = createModeState.transitionRulesInputs[transitionRuleInputIndex + 1];

        setCreateModeState((state) => ({
            ...state,

            // swap target and next inputs:
            transitionRulesInputs: state.transitionRulesInputs.map((transitionRuleInput, idx) => {
                if(idx === transitionRuleInputIndex){
                    return nextTransitionRuleInput;
                }
                else if (idx === transitionRuleInputIndex + 1){
                    return targetTransitionRuleInput;
                }
                else{
                    return transitionRuleInput;
                }
            })
        }));
    }

    const onAddTransitionRuleInput = (event) => {
        event.preventDefault();

        setCreateModeState((state) => ({
            ...state,
            transitionRulesInputs: [...state.transitionRulesInputs, {
                startState: '',
                lookedChar: '',
                endState: '',
                charToWrite: '',
                headDirection: 'NONE'
            }]
        }));
    }

    const onDeleteTransitionRuleInput = (transitionRuleInputIndex) => {
        if(createModeState.transitionRulesInputs.length < 2){ // impossible case (corresponding button is disabled)
            return; // perform no action
        }

        setCreateModeState((state) => ({
            ...state,

            // filter out target transitionRuleInput
            transitionRulesInputs: state.transitionRulesInputs.filter((transitionRuleInput, idx) => {
                return idx !== transitionRuleInputIndex; // accept all, except target stateInput
            }),
        }));
    }

    // performs necessary checking on inputs, and create Objects of entities
    const onSwitchToRunMode = (event) => {
        event.preventDefault();

        let errors = []; // createModeState.switchToRunModeErrors

        // Check Alphabet
        if(createModeState.alphabetChars.length === 0){
            errors.push(new TmParsingError('Alphabet', undefined, "Alphabet can't be empty"));
        }
        if(createModeState.alphabetEmptyCellChar === ''){
            errors.push(new TmParsingError('Alphabet', undefined, "The empty cell char must be chosen"));
        }

        // Check states
        // some preprocessing to check for uniqueness of name
        let validStatesNames = createModeState.statesInputs
            .map(i => i.name)
            .filter(name => name !=='' && /^[a-z0-9_]+$/.test(name));
        const statesNameOccurrencesCount = new Map([...new Set(validStatesNames)].map(
            x => [x, validStatesNames.filter(y => y === x).length]
        )); // https://stackoverflow.com/a/35101824

        for (let i = 0; i < createModeState.statesInputs.length; i++) { // createModeState.statesInputs is not empty
            let stateInput = createModeState.statesInputs[i];

            if(stateInput.name === ''){ // name is non-empty
                errors.push(new TmParsingError('States', i+1, "State name must be not empty"));
            }
            else{
                if(!/^[a-z0-9_]+$/.test(stateInput.name)){ // name follows the required format
                    errors.push(new TmParsingError('States', i+1,
                        "State name can contain only latin characters, digits and underscores"));
                } // name is valid
                else{ // need to check if name is unique
                    if(statesNameOccurrencesCount.get(stateInput.name) > 1){ // check number of occurrences of name
                        errors.push(new TmParsingError('States', i+1,
                            "State name must be unique"));
                    }
                }
            }
        }

        // check if initialStateInputId is chosen
        if(!createModeState.initialStateInputId){
            errors.push(new TmParsingError('States', undefined,
                "The initial state must be chosen"));
        }

        // check if at least one final state is chosen
        if(!createModeState.statesInputs.some((si) => si.final)){
            errors.push(new TmParsingError("States", undefined,
                "At least one final state must be chosen"));
        }

        // check transitionRulesInputs
        // need to check only if not empty (because other corresponds (due to using <select/>))
        for(let i = 0; i < createModeState.transitionRulesInputs.length; i++){
            let transitionRuleInput = createModeState.transitionRulesInputs[i];

            if(transitionRuleInput.startState === ''){
                errors.push(new TmParsingError('Transitions relation', i+1,
                    "The start state must be chosen"));
            }
            if(transitionRuleInput.lookedChar === ''){
                errors.push(new TmParsingError('Transitions relation', i+1,
                    "The looked char must be chosen"));
            }
            if(transitionRuleInput.endState === ''){
                errors.push(new TmParsingError('Transitions relation', i+1,
                    "The end state must be chosen"));
            }
            if(transitionRuleInput.charToWrite === ''){
                errors.push(new TmParsingError('Transitions relation', i+1,
                    "The char to write must be chosen"));
            }
        }

        if(errors.length > 0){ // return if some errors
            setCreateModeState((state) => ({
                ...state,
                switchToRunModeErrors: errors
            }));
            return;
        }
        // here, errors is empty



        // init alphabet
        let alphabet; // TmAlphabet
        try{
            alphabet = new TmAlphabet(createModeState.alphabetChars, createModeState.alphabetEmptyCellChar);
        }
        catch(e){
            errors.push(new TmParsingError("Alphabet", undefined, e.message));
        }

        // init states and final states
        let states = []; // TmState[]
        let initialState;
        let finalStates = []; // TmState[]
        let initialStateIndex = parseStateInputIndexFromId(createModeState.initialStateInputId);
        for (let i = 0; i < createModeState.statesInputs.length; i++) {
            try{
                let description = createModeState.statesInputs[i].description.trim();
                description = description !== '' ? description : undefined; // make undefined if ''

                let state = new TmState(createModeState.statesInputs[i].name, description)
                states.push(state);

                if(i === initialStateIndex){ // mark as initial
                    initialState = state;
                }
                if(createModeState.statesInputs[i].final){ // add to final
                    finalStates.push(state);
                }
            }
            catch(e){
                errors.push(new TmParsingError("States", i+1, e.message));
            }
        }

        // check if no errors, because correct initialization of TmTransitionRelation depends on alphabet and states
        // and if some errors revealed in initialization of alphabet and states,
        // then correct of TmTransitionRelation is impossible
        if(errors.length > 0){ // return if some errors
            setCreateModeState((state) => ({
                ...state,
                switchToRunModeErrors: errors
            }));
            return;
        }
        // here, errors array is empty


        // init transition rules
        let transitionRules = []; // TmTransitionRule[]
        for (let i = 0; i < createModeState.transitionRulesInputs.length; i++) {
            let transitionRuleInput = createModeState.transitionRulesInputs[i];
            try{
                transitionRules.push(new TmTransitionRule(
                    findStateByName(states, transitionRuleInput.startState),
                    transitionRuleInput.lookedChar,
                    findStateByName(states, transitionRuleInput.endState),
                    transitionRuleInput.charToWrite,
                    TmHeadTransitionDirection.fromString(transitionRuleInput.headDirection)
                ));
            }
            catch(e){
                errors.push(new TmParsingError("Transitions relation", i+1, e.message));
            }
        }

        if(errors.length > 0){ // return if some errors
            setCreateModeState((state) => ({
                ...state,
                switchToRunModeErrors: errors
            }));
            return;
        }
        // here, errors array is empty

        // init TmTransitionsRelation
        let transitionsRelation;
        try{
            transitionsRelation = new TmTransitionsRelation(transitionRules);
        }
        catch(e){
            errors.push(new TmParsingError("Transitions relation", undefined, e.message));
        }

        if(errors.length > 0){ // return if some errors
            setCreateModeState((state) => ({
                ...state,
                switchToRunModeErrors: errors
            }));
            return;
        }
        // here, errors array is empty


        // erase all previous errors
        setCreateModeState((state) => ({
            ...state,
            switchToRunModeErrors: []
        }))


        // callback that actually switches to RUN mode (inits runModeState)
        switchToRunMode(states, alphabet, transitionsRelation, initialState, finalStates);
        // pass there all created variables
    }


    const onExportTmInputs = (event) => {
        event.preventDefault();

        const tmInputs = {
            alphabetChars: createModeState.alphabetChars,
            alphabetEmptyCellChar: createModeState.alphabetEmptyCellChar,
            statesInputs: createModeState.statesInputs,
            initialStateInputId: createModeState.initialStateInputId,
            transitionRulesInputs: createModeState.transitionRulesInputs
        };
        const tmInputsString = JSON.stringify(tmInputs, null, 2); // formatted JSON

        exportJsonFile('tm.json', tmInputsString);
    }

    // by analogy with URM program import
    const onImportTmInputs = (event) => {
        const file = event.target.files[0];

        // validate file existence and type of file
        if (!file) {
            alert("No file selected. Please choose a file");
            return;
        }
        if (!file.type.startsWith("application/json")) {
            alert("Unsupported file type. Please select a json file.");
            return;
        }

        // read the file
        const reader = new FileReader();
        reader.onload = () => {
            const content = reader.result;

            // parse and validate consistency of file content
            let obj;
            try{
                obj = JSON.parse(content);

                // validate file content and check its consistency
                let validationResult = isConsistentImportedTmInputs(obj);
                if(!validationResult[0]){
                    alert(`File is invalid: ${validationResult[1]}`);
                    return;
                }
            } catch(e){
                alert('File is invalid');
                return;
            }

            // set inputs
            setCreateModeState((state) => ({
                ...state,
                alphabetChars: obj.alphabetChars,
                alphabetEmptyCellChar: obj.alphabetEmptyCellChar,
                statesInputs: obj.statesInputs,
                initialStateInputId: obj.initialStateInputId,
                uniqueValidStatesNames: obj
                    .statesInputs.map(si => si.name)
                    .filter(n => /^[a-z0-9_]+$/.test(n)),
                transitionRulesInputs: obj.transitionRulesInputs
            }));
        };
        reader.onerror = () => {
            alert("Error reading the file. Please try again.");
        };
        reader.readAsText(file);
    }

    /**
     * Check if imported TM's inputs object is consistent and can be fit in page inputs.
     * Considers everything that the user can write or select in the input fields as valid.
     * @param obj {Object}
     * @returns {[]} <code>[isConsistent, error]</code>
     */
    const isConsistentImportedTmInputs = (obj) => {
        // check top-level keys
        if (!Array.isArray(obj.alphabetChars) ||
            !Array.isArray(obj.statesInputs) ||
            !Array.isArray(obj.transitionRulesInputs)) {
            return [false, 'alphabetChars, statesInputs, transitionRulesInputs must be an arrays'];
        }
        if(!isString(obj.alphabetEmptyCellChar)){
            return [false, 'alphabetEmptyCellChar must be a string'];
        }
        if (obj.initialStateInputId !== undefined &&
            !isString(obj.initialStateInputId)){ // alphabetEmptyCellChar can be undefined or string
            return [false, 'initialStateInputId must be either undefined either a string'];
        }

        // check items in alphabetChars
        if (!obj.alphabetChars.every(
            char => isString(char) &&
            char.length === 1 &&
            !containsWhitespace(char))) {
            return [false, 'each character of the alphabet must be a string with length 1 and shouldn\'t contain a whitespace'];
        }

        // check alphabetEmptyCellChar
        if(obj.alphabetEmptyCellChar !== '' &&
            !containsEqualElement(obj.alphabetChars, obj.alphabetEmptyCellChar)){
            return [false, 'alphabetEmptyCellChar, if not an empty string, must be one of the characters of the alphabet'];
        }

        // check statesInputs items
        if(obj.statesInputs.length === 0){
            return [false, 'statesInputs must be non-empty'];
        }
        for (const state of obj.statesInputs) {
            if (!isString(state.name) ||
                !isString(state.description) ||
                typeof state.final !== 'boolean') {
                return [false, 'each stateInput must have the following properties: ' +
                'name (string), description (string), final (boolean)'];
            }
            if(state.name.length > 5 ||
                state.description.length > 100){
                return [false, 'stateInput.name must have length <= 5, stateInput.description must have length <= 100'];
            }
        }

        // check initialStateInputId
        if(obj.initialStateInputId){
            let initialStateInputIndex;
            try{
                initialStateInputIndex = parseStateInputIndexFromId(obj.initialStateInputId);
            } catch(e){
                return [false, 'initialStateInputId has incorrect format'];
            }
            if(initialStateInputIndex >= obj.statesInputs.length){
                return [false, 'initialStateInputId doesn\'t match any state input'];
            }
        }

        // check transitionRulesInputs items
        let uniqueValidStatesNames = obj.statesInputs
            .map(si => si.name)
            .filter(n => /^[a-z0-9_]+$/.test(n));

        if(obj.transitionRulesInputs.length === 0){
            return [false, 'transitionRulesInputs must be non-empty'];
        }
        for (const rule of obj.transitionRulesInputs) {
            if (!isString(rule.startState) ||
                !isString(rule.lookedChar) ||
                !isString(rule.endState) ||
                !isString(rule.charToWrite) ||
                !isString(rule.headDirection)) {
                return [false, 'each transitionRuleInput must have the following properties: ' +
                'startState (string), lookedChar (string), endState (string), charToWrite (string), headDirection (string)'];
            }
            if((rule.startState.length > 0 && !containsEqualElement(uniqueValidStatesNames, rule.startState)) ||
                (rule.endState.length > 0 && !containsEqualElement(uniqueValidStatesNames, rule.endState))){
                return [false, 'transitionRuleInput.startState and transitionRuleInput.endState ' +
                'must be the names of some valid-named states'];
            }
            if((rule.lookedChar.length > 0 && !containsEqualElement(obj.alphabetChars, rule.lookedChar)) ||
                (rule.charToWrite.length > 0 && !containsEqualElement(obj.alphabetChars, rule.charToWrite))){
                return [false, 'transitionRuleInput.lookedChar and transitionRuleInput.charToWrite ' +
                'must be the characters of the alphabet'];
            }
            if(rule.headDirection !== 'LEFT' &&
                rule.headDirection !== 'RIGHT' &&
                rule.headDirection !== 'NONE'){
                return [false, 'transitionRuleInput.headDirection must be one of the following: ' +
                'LEFT, RIGHT, NONE'];
            }
        }

        return [true, null];
    }



    return (
        <>
            {/* Import/Export TM */}
            <div className="d-flex flex-column align-items-center mt-3">
                {/* Import file input */}
                <div className="d-flex flex-row justify-content-center align-items-center">
                    <div className={'me-2'}>
                        <label htmlFor="input-import-tm-inputs" className="form-label m-0">
                            Import TM:
                        </label>
                    </div>
                    <div>
                        <input type="file" className="form-control" id="input-import-tm-inputs"
                               onChange={onImportTmInputs} accept={'application/json'} />
                    </div>
                </div>

                {/* Export into file button */}
                <button type="button" className="btn btn-primary m-1"
                        onClick={onExportTmInputs}
                        disabled={false}>
                    Export TM
                </button>
            </div>

            <h4 className={'mt-5 mb-0'}>Alphabet</h4>
            <p className={'m-1 mt-0 p-0 text-muted small text-center'}>
                <b>Template alphabets:</b>
                &nbsp;
                <a href="#" onClick={onSetBinaryAlphabet}>
                    binary
                </a>
                &nbsp;
                <a href="#" onClick={onSetDigitAlphabet}>
                    digit
                </a>
            </p>

            {/* Alphabet input */}
            {/* For notes, repeats the structure of bottom div */}
            <div className="row">
                <div className="row col-9">
                    <div className="col-2">{/* Label */}</div>
                    <div className="col text-start">
                        <p className={'m-1 p-0 text-muted small text-start'}>
                            Characters could be separated by space(s).
                            Whitespaces are ignored. <b>Example:</b> abcd</p>
                    </div>
                </div>
                <div className="col"></div>
            </div>

            <div className="row">
                {/* Input for alphabet characters */}
                <div className="row col-9">
                    <label className={'col-2 text-end'} htmlFor={'input-alphabet-chars'}>Alphabet</label>

                    <div className="col">
                        {/* input */}
                        <input name="name" id='input-alphabet-chars' type='text' required
                               className={"form-control col"}
                               defaultValue={createModeState.alphabetChars.join('')}
                               onChange={onAlphabetCharsInputChanged}/>

                        {/* parsing errors for input */}
                        <LineByLineTextErrorsComponent errors={createModeState.alphabetCharsInputErrors} />
                    </div>
                </div>

                {/* Input for empty-cell character */}
                <div className="row col">
                    <label className='col-8 text-end' htmlFor='input-alphabet-empty-cell-char'>Empty cell char</label>

                    <div className="col">
                        {/* input */}
                        <select id='input-alphabet-empty-cell-char' className='form-control'
                                value={createModeState.alphabetEmptyCellChar}
                                onChange={onAlphabetEmptyCellCharChanged}>
                            <option value={''}> {/* using empty string for controlled input recommended by React error */}
                                {/* 'Nothing selected' option */}
                            </option>
                            {(createModeState.alphabetChars !== undefined) && (
                                <>
                                    {
                                        createModeState.alphabetChars.map((char, index) => (
                                            <option key={index} value={char}>
                                                {char}
                                            </option>
                                        ))
                                    }
                                </>
                            )}
                        </select>
                    </div>
                </div>
            </div>


            <h4 className={'mt-5'}>States</h4>

            {/* States input table */}
            <div className="col states-input-container">

                {/* Header */}
                <div className="states-input-header row m-0 mb-2">
                    <div className="col-3 p-0">
                        <p className="m-0 p-0">Name</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            Unique, no whitespaces, max 5 chars</p>
                    </div>
                    <div className="col-4 p-0">
                        <p className="m-0 p-0">Description</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            Max 100 chars</p>
                    </div>
                    <div className="col-1 p-0">
                        <p className="m-0 p-0">Initial</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            Is initial?</p>
                    </div>
                    <div className="col-1 p-0">
                        <p className="m-0 p-0">Final</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            Is final?</p>
                    </div>
                    <div className="col-3 p-0">
                        {/* Empty place for delete button */}
                    </div>
                </div>

                {/* Actually inputs */}
                <div className="states-input-items col">
                    {
                        createModeState.statesInputs.map((stateInput, index) => (
                            <TmStateInputComponent key={index}
                                                   index={index} statesInputsCount={createModeState.statesInputs.length}
                                                   stateInput={stateInput}
                                                   checkedInitialStateId={createModeState.initialStateInputId}
                                                   inputErrors={createModeState.statesInputsErrors[index]}
                                                   onNameChanged={onStateInputNameChanged}
                                                   onDescriptionChanged={onStateInputDescriptionChanged}
                                                   onInitialChanged={onInitialStateInputChanged}
                                                   onFinalChanged={onStateInputFinalChanged}
                                                   onRaiseUpInput={onRaiseUpStateInput}
                                                   onPutDownInput={onPutDownStateInput}
                                                   onDeleteInput={onDeleteStateInput}
                            />
                        ))
                    }

                    {/* add button */}
                    <div className="d-flex flex-row justify-content-center mb-5">

                        <button type="button"
                                className="btn btn-lg btn-primary m-1 mb-0 text-center"
                                onClick={onAddStateInput}>
                            <p className={'m-0 p-0'}>
                                <FontAwesomeIcon icon={faPlus}/>
                            </p>
                        </button>
                    </div>
                </div>
            </div>



            <h4 className={'mt-5'}>Transitions relation</h4>

            {/* Transitions relation input table */}
            <div className="col states-input-container">

                {/* Header */}
                <div className="states-input-header row m-0 mb-2">
                    <div className="col-2 p-0">
                        <p className="m-0 p-0">Start state</p>
                    </div>

                    <div className="col-1 p-0">
                        <p className="m-0 p-0">Looker char</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            By TM head</p>
                    </div>

                    <div className="col-1 p-0">
                        {/* Empty place for -> */}
                    </div>

                    <div className="col-2 p-0">
                        <p className="m-0 p-0">End state</p>
                    </div>

                    <div className="col-1 p-0">
                        <p className="m-0 p-0">Char to write</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            On Looked char</p>
                    </div>

                    <div className="col-2 p-0">
                        <p className="m-0 p-0">Head direction</p>
                        <p className={'m-0 p-0 text-muted small text-center'}>
                            To move TM head</p>
                    </div>

                    <div className="col-3 p-0">
                        {/* Empty place for up, down, delete buttons */}
                    </div>
                </div>

                {/* Actually inputs */}
                <div className="states-input-items col">
                    {
                        createModeState.transitionRulesInputs.map((transitionRuleInput, index) => (
                            <TmTransitionRuleInputComponent key={index}
                                                            index={index}
                                                            transitionRulesInputsCount={createModeState.transitionRulesInputs.length}
                                                            transitionRuleInput={transitionRuleInput}
                                                            statesNames={createModeState.uniqueValidStatesNames}
                                                            alphabetChars={createModeState.alphabetChars}
                                                            onStartStateChanged={onTransitionRuleInputStartStateChanged}
                                                            onEndStateChanged={onTransitionRuleInputEndStateChanged}
                                                            onLookedCharChanged={onTransitionRuleInputLookedCharChanged}
                                                            onCharToWriteChanged={onTransitionRuleInputCharToWriteChanged}
                                                            onHeadDirectionChanged={onTransitionRuleInputHeadDirectionChanged}
                                                            onRaiseUpInput={onRaiseUpTransitionRuleInput}
                                                            onPutDownInput={onPutDownTransitionRuleInput}
                                                            onDeleteInput={onDeleteTransitionRuleInput}
                            />
                        ))
                    }

                    {/* add button */}
                    <div className="d-flex flex-row justify-content-center mb-5">
                        <button type="button"
                                className="btn btn-lg btn-primary m-1 mb-0 text-center"
                                onClick={onAddTransitionRuleInput}>
                            <p className={'m-0 p-0'}>
                                <FontAwesomeIcon icon={faPlus}/>
                            </p>
                        </button>
                    </div>
                </div>
            </div>


            {/* Switch to RUN mode btn + corresponding errors */}
            <div className="row m-0 mt-2 mb-2">
                <div className="d-flex flex-row justify-content-center mb-1">
                    <button type="button"
                            className="btn btn-lg btn-primary m-1 mb-0 text-center"
                            onClick={onSwitchToRunMode}>
                        <p className={'m-0 p-0'}>
                            To RUN mode
                        </p>
                    </button>
                </div>
            </div>

            {/* buffer: when length > 0 delete it to make errors visible immediately */}
            {createModeState.switchToRunModeErrors.length === 0 && (
                <>
                    <div className="buffer">
                    </div>
                </>
            )}

            {/* Errors */}
            {createModeState.switchToRunModeErrors.length > 0 &&
                (
                    <>
                        <h4 className={'text-danger'}>Errors:</h4>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead className="table-light">
                                <tr>
                                    <th className={'text-danger'}>Part</th>
                                    <th className={'text-danger'}>Item number</th>
                                    <th className={'text-danger'}>Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                {createModeState.switchToRunModeErrors.map((error, idx) => (
                                    // error is TmParsingError
                                    <tr key={idx}>
                                        <td>{error.part}</td>
                                        <td>{error.lineIndex}</td>
                                        <td className="text-start">{error.description}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </>

                )
            }
        </>
    );
}